/* NANEND 菜单行点击 v1 - 2026-10-14 (v484)
   M 端抽屉・二级/三级面板：带 ▾ 箭头的分类行——点「行内空白」（非文字、非箭头）时
   等价于点击 ▾（进入下一级面板），不再直接跳转集合页。
   文字链接 / ▾ 按钮 / 无箭头行（空白=跳集合）行为不变。
   幂等：纯事件监听，无 DOM 写入。回滚：删除本文件引用即可。 */
(function () {
  'use strict';
  var SEL_ROW = '.menu-drawer .nested-submenu .menu__item-title';
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var row = t.closest(SEL_ROW);
    if (!row) return;
    var btn = row.querySelector(':scope > button');
    if (!btn) return;                                  /* 无箭头行：不干预 */
    if (btn === t || btn.contains(t)) return;          /* 点在箭头上 → 原生 */
    if (t.closest('a')) return;                        /* 点在文字链接上 → 原生跳转 */
    e.preventDefault();
    btn.click();                                       /* 空白 → 展开下一级 */
  }, false);
})();
